import type { PlatformType } from "../types";

const sizeScale: Record<PlatformType, number> = {
  ship: 1.0,
  helicopter: 1.0,
  truck: 0.9,
};

// 🎨 High-visibility filter matrix to deliver a crisp 1px outline on dark maps
const SVG_FILTER_OUTLINE = `
  <defs>
    <filter id="crisp-outline" x="-20%" y="-20%" width="140%" height="140%">
      <feMorphology in="SourceAlpha" result="morphed" operator="dilate" radius="1" />
      <feColorMatrix in="morphed" result="colored" type="matrix" values="
        0 0 0 0 0.06
        0 0 0 0 0.06
        0 0 0 0 0.07
        0 0 0 1 0
      " />
      <feMerge>
        <feMergeNode in="colored" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>
`;

const siloIcons: Record<
  PlatformType,
  (color: string, scale: number) => string
> = {
  ship: (color, s) => `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="154" height="154" viewBox="0 0 154 154">
    ${SVG_FILTER_OUTLINE}
    <g transform="translate(77 77) scale(${s}) translate(-77 -77)" filter="url(#crisp-outline)">
      <g id="Mask_Group_2" data-name="Mask Group 2" transform="translate(-78 -1633)">
        <g id="Group_10302" data-name="Group 10302" transform="translate(1.5)">
          <g id="Group_10301" data-name="Group 10301" transform="translate(0 -12.502)">
            <path id="Path_50" data-name="Path 50" d="M61.38,0C22.007,2.065,0,28.422,0,28.422H12.773L33.723,48.416V62.464S57.849,48.2,61.38,0" transform="matrix(0.719, -0.695, 0.695, 0.719, 110, 1689.883)" fill="${color}"/>
            <path id="Path_54" data-name="Path 54" d="M0,18.587v-4.8l1.831-2.078V2.121L4,0,6.066,2.121v9.584H9.848V2.121L12.07,0l1.971,2.121v9.584l2,2.078v4.8Z" transform="translate(145.5 1672.443)" fill="${color}"/>
            <path id="Path_67" data-name="Path 67" d="M0,25.663V19.029l2.527-2.868V2.929L5.519,0,8.375,2.929V16.161H13.6V2.929L16.664,0l2.722,2.929V16.161l2.767,2.868v6.633Z" transform="matrix(-1, -0.017, 0.017, -1, 164.478, 1789.698)" fill="${color}"/>
            <path id="Union_1" data-name="Union 1" d="M9.5,51.332a9.5,9.5,0,0,1-9.5-9.5v-19q0-.318.021-.632V0L10.091,13.333H38.622q.132,0,.263,0L48.09,0v22.04q.032.391.032.79v19a9.5,9.5,0,0,1-9.5,9.5Z" transform="translate(128.999 1747.146)" fill="${color}"/>
            <g id="Rectangle_11718" data-name="Rectangle 11718" transform="translate(139.5 1706.816)" fill="${color}">
              <rect width="28" height="43.665" rx="3"/>
            </g>
            <path id="Path_70" data-name="Path 70" d="M0,18.587v-4.8l1.831-2.078V2.121L4,0,6.066,2.121v9.584H9.848V2.121L12.07,0l1.971,2.121v9.584l2,2.078v4.8Z" transform="translate(161.545 1789.969) rotate(180)" fill="${color}"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
  `,
  helicopter: (color, s) => `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="154" height="154" viewBox="0 0 154 154">
    ${SVG_FILTER_OUTLINE}
    <g transform="translate(77 77) scale(${s}) translate(-77 -77)" filter="url(#crisp-outline)">
      <g id="Mask_Group_3" data-name="Mask Group 3" transform="translate(-343 -1494)">
        <g id="Group_10318" data-name="Group 10318" transform="translate(71 2.279)">
          <path id="Union_2" data-name="Union 2" d="M-10073.9,3993.908l2.543-3.826-17.159,3.356a6.761,6.761,0,0,1-1.918,2.945v.365a1.461,1.461,0,0,1-.478-.11,1.715,1.715,0,0,1-.521.11v-.433a7.087,7.087,0,0,1-1.669-2.878l-15.692-3.356,2.326,3.826-1.906,3.371-4.928-6.018.6-15.748,1.484,3.44,17.108-3.44-7.633-51.683s-26.711-5.588-27.8-6.725.03-11.545.386-11.545,22.19-4.078,23.693-10.638,4.251-26.764,4.251-26.764,3.066-16.238,10.1-20.925V3847c.064.035.129.071.192.108.059-.037.117-.073.177-.108v.212c7.716,4.659,11.08,20.946,11.08,20.946s3.008,20.208,4.649,26.764,25.517,10.638,25.908,10.638,1.609,10.409.424,11.545-30.4,6.725-30.4,6.725l-8.344,51.683,18.705,3.44,1.624-3.44.656,15.748-5.388,6.018Z" transform="translate(10438.082 -2353.279)" fill="${color}"/>
          <line id="Line_62" data-name="Line 62" y1="98" x2="98" transform="translate(300 1509.5)" fill="none" stroke="${color}" stroke-linecap="round" stroke-width="5"/>
          <line id="Line_63" data-name="Line 63" x2="98" y2="98" transform="translate(300 1509.5)" fill="none" stroke="${color}" stroke-linecap="round" stroke-width="5"/>
        </g>
      </g>
    </g>
  </svg>
  `,
  truck: (color, s) => `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="154" height="154" viewBox="0 0 154 154">
    ${SVG_FILTER_OUTLINE}
    <g transform="translate(77 77) scale(${s}) translate(-77 -77)" filter="url(#crisp-outline)">
      <g id="Mask_Group_4" data-name="Mask Group 4" transform="translate(-527 -1494)">
        <g id="Group_10321" data-name="Group 10321" transform="translate(33 2)">
          <g id="Rectangle_11721" data-name="Rectangle 11721" transform="translate(545 1497)" fill="${color}">
            <rect width="52" height="38" rx="3"/>
          </g>
          <g id="Subtraction_1" data-name="Subtraction 1" transform="translate(545 1537)" fill="${color}">
            <path d="M 48.99959945678711 98.49909973144531 L 2.999701023101807 98.49909973144531 C 1.621363639831543 98.49909973144531 0.500001072883606 97.37774658203125 0.500001072883606 95.99941253662109 L 0.500001072883606 2.999699831008911 C 0.500001072883606 1.620862245559692 1.621363639831543 0.4990997314453125 2.999701023101807 0.4990997314453125 L 48.99959945678711 0.4990997314453125 C 50.37843704223633 0.4990997314453125 51.50020217895508 1.620862245559692 51.50020217895508 2.999699831008911 L 51.50020217895508 95.99941253662109 C 51.50020217895508 97.37774658203125 50.37843704223633 98.49909973144531 48.99959945678711 98.49909973144531 Z M 9.999900817871094 12.06669998168945 C 8.621500968933105 12.06669998168945 7.500101089477539 13.18809986114502 7.500101089477539 14.56649971008301 L 7.500101089477539 83.52809906005859 C 7.500101089477539 84.90650177001953 8.621500968933105 86.02790069580078 9.999900817871094 86.02790069580078 L 43.00020217895508 86.02790069580078 C 44.37860107421875 86.02790069580078 45.5 84.90650177001953 45.5 83.52809906005859 L 45.5 14.56649971008301 C 45.5 13.18809986114502 44.37860107421875 12.06669998168945 43.00020217895508 12.06669998168945 L 9.999900817871094 12.06669998168945 Z"/>
          </g>
          <g id="Rectangle_11723" data-name="Rectangle 11723" transform="translate(550 1503)" fill="${color}">
            <rect width="20" height="13" rx="3"/>
          </g>
          <g id="Rectangle_11724" data-name="Rectangle 11724" transform="translate(573 1503)" fill="${color}">
            <rect width="19" height="13" rx="3"/>
          </g>
          <g id="Rectangle_11726" data-name="Rectangle 11726" transform="translate(596 1508)" fill="${color}">
            <rect width="8" height="21" rx="1"/>
          </g>
          <g id="Rectangle_11727" data-name="Rectangle 11727" transform="translate(596 1600)" fill="${color}">
            <rect width="8" height="21" rx="1"/>
          </g>
          <g id="Rectangle_11728" data-name="Rectangle 11728" transform="translate(538 1600)" fill="${color}">
            <rect width="8" height="21" rx="1"/>
          </g>
          <g id="Rectangle_11729" data-name="Rectangle 11729" transform="translate(538 1510)" fill="${color}">
            <rect width="8" height="21" rx="1"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
  `,
};

/**
 * Builds vector imagery for specialized hardware matrix placement loops
 */
export function createSiloMarker(
  category: string = "ship",
  isSelected: boolean = false,
): string {
  const sanitizedKey = category.toLowerCase().trim() as PlatformType;

  const baseScale = sizeScale[sanitizedKey];
  const isMapped = baseScale !== undefined;
  const scale = isMapped ? baseScale : 1.0;

  const iconTemplate = siloIcons[sanitizedKey] || siloIcons["ship"];

  if (!isMapped) {
    console.warn(
      `⚠️ Unknown platform asset key evaluated: "${category}" -> Defaulting safely to ship marker format.`,
    );
  }

  // 🌟 UPDATED: Shifted to amber spectrums matching the navigation lines
  const color = isSelected ? "#FFEBB3" : "#F5F5F5";

  return iconTemplate(color, scale);
}
